import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import TapIcon from '../../../services/TapIcon';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import { toast } from 'react-toastify';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'; 

const AddNotificationType = ({ history }) => {  
    const location = useLocation(); 
    
    const access_token = useSelector(state => state.auth.access_token);
    const [submitLoading, setSubmitLoading] = useState(false);
    const notificationUrl = BACKOFFICE_BASE_URL + '/notification_type';
    
    const [formData, setFormData] = useState({
        id: "",
        name: "",
        type: ""
    });
    const [isEditMode, setIsEditMode] = useState(false);

    const backToListing = () => {
        history.push({ pathname: '/notification_type' });
    };

    useEffect(() => {
        initialFormData();
    }, []);

    const initialFormData = () => {
        if (location?.state?.editNotificationData) {
            const editData = location.state.editNotificationData;
            setFormData({
                id: editData.id || "",
                name: editData.name || "",
                type: editData.type || ""
            });
            setIsEditMode(true);
        } else {
            console.log("No edit data found");
        }
    };

    const submitDataForm = (e) => {
        e.preventDefault();
        setSubmitLoading(true);

        if (isEditMode) {
            HttpAPICall.withAthorization('PUT', `${notificationUrl}/edit`, access_token, {}, {
                id: formData.id,
                name: formData.name,
                type: parseInt(formData.type)
            }, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                history.push({ pathname: '/notification_type', state: { id: formData.id } });
            }).finally(() => setSubmitLoading(false));
        } else {
            HttpAPICall.withAthorization('POST', `${notificationUrl}/add`, access_token, {}, {
                name: formData.name,
                type: parseInt(formData.type)
            }, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                backToListing();
            }).finally(() => setSubmitLoading(false));
        }
    };

    const formInputHandler = (e) => {
        setFormData(pre => ({ ...pre, [e.target.name]: e.target.value }));
    };

    const formDatajsx = () => {
        return (
            <>
                <form className="bg-white p-3" onSubmit={submitDataForm} id="saveResourceForm">
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="name" className="form-label require">Notification Name</label>
                        </div>
                        <div className="col-sm-8">
                            <input
                                name="name"
                                type="text"
                                value={formData.name}
                                className="form-control"
                                autoComplete="off"
                                required={true}
                                onChange={formInputHandler}
                                placeholder="Please enter Notification Name"
                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="type" className="form-label require">Type</label>
                        </div>
                        <div className="col-sm-8">
                            <input
                                name="type"
                                type="number"
                                value={formData.type}
                                className="form-control"
                                autoComplete="off"
                                required={true}
                                onChange={formInputHandler}
                                placeholder="Please enter Type "
                            />
                        </div>
                    </div>
                    <div className="col-12 text-end fixed_footer">
                        <button type="button" className="btn btn-secondary mx-3" onClick={backToListing} disabled={submitLoading}>Cancel</button>
                        <button type="submit" className="btn btn-primary mx-2" disabled={submitLoading}>
                            Save {submitLoading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                        </button>
                    </div>
                </form>
            </>
        );
    };

    const addNotificationTypeJsx = () => {
        return (
            <>
                <div className="page_title row m0">
                    <div className="col-12">
                        <h3>{isEditMode ? "Edit " : "Add "} Notification Type</h3>
                        <div className="text-end mt15">
                            <button type="button" className="btn btn-secondary" onClick={backToListing}>
                                <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-action" />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', 'col-12'].join(' ')}>{formDatajsx()}</div>
                    </div>
                </div>
            </>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>{isEditMode ? "Edit" : "Add"} Notification Type</title></Helmet>
            {addNotificationTypeJsx()}
        </ApplicationLayout>
    );
};

export default AddNotificationType;